module.exports = __webpack_public_path__ + "static/ss7.b71426a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/ss/ss7.png
// module id = 1170
// module chunks = 112875127094159